import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';

import CalendarHeatmap from 'react-calendar-heatmap';
import { DropdownButton, MenuItem } from 'react-bootstrap';

import 'react-calendar-heatmap/dist/styles.css';
import '../styles/post-list.css';

import Icon from './Icon';

function addToCollection(itemType, collectionId, itemId, onSave) {
  const url = `/api/collection/${collectionId}/add/${itemType}/${itemId}`;
  const options = {
    credentials: 'same-origin',
    headers: {"Content-Type": "application/json"},
    method: 'POST'
  };
  fetch(url, options);
}

function CollectionDropdown({ collections, post }) {
  if (!collections) {
    return null;
  }
  return (<DropdownButton
      bsStyle='default'
      bsSize='xsmall'
      className='collection-btn'
      noCaret
      title={<Icon name='plus-sign'/>}
      key={post.id}
      id={`dropdown-basic-${post.id}`}>
      <MenuItem header>Add to collection</MenuItem>
      {collections.map((c) => {
        return <MenuItem
          eventKey={c.id}
          key={c.id}
          onSelect={(e) => addToCollection('post', c.id, post.id)}>
          {c.name}
        </MenuItem>;
      })}
    </DropdownButton>);
}

function PostListItem({ collections, post }) {
  const lines = post.content.match(/[^\r\n]+/g);
  const quotes = lines.filter((l) => l.startsWith('>')).length;

  const quoteIcon = quotes > 0 ? <Icon name='book' /> : null;

  return (<div className='post-list-item'>
    <span className='post-list-item-date'>
      {moment(post.day).format('DD MMM YYYY')}
    </span>
    <Link to={`/post/${post.id}`}>{post.title}</Link>
    <span className='post-list-options'>
      <Link to={`/write/${post.id}`}><Icon name='edit'/></Link> {quoteIcon}
    </span>
    <CollectionDropdown collections={collections} post={post} />
  </div>);
}

export default function PostList({ collections, posts }) {
  const sorted = posts.sort((a, b) => {
    if (a.day > b.day) {
      return -1;
    } else if (a.day === b.day) {
      return a.id > b.id ? -1 : 1;
    } else {
      return 1;
    }
  });

  const grouped = {};
  const days = {};
  sorted.forEach((p) => {
    days[p.day] = (days[p.day] || 0) + 1;
    const [year, month] = p.day.split('-');
    const key = `${year}-${month}`;
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(p);
  });

  const organized = Object.keys(days).map((d) => ({date: d, count: days[d]}));

  const monthOrder = Object.keys(grouped).sort((a, b) => a > b ? -1 : 1);

  return (<div className='post-list'>
    <div className='heatmap'>
      <CalendarHeatmap
        gutterSize={2}
        startDate={new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 365)}
        endDate={new Date()}
        values={organized}
      />
    </div>
    {monthOrder.map((month) => {
      return (<div key={month}>
        {grouped[month].map((p) => <PostListItem collections={collections} key={p.id} post={p} />)}
      </div>);
    })}
  </div>);
}



// WEBPACK FOOTER //
// ./src/components/PostList.js